import {configureStore} from '@reduxjs/toolkit'
import storage from 'redux-persist/es/storage'
import {persistReducer, persistStore} from 'redux-persist'
import AuthSlice from '../slices/authSlice'
import AccountSlice from '../slices/accountSlice'
import {usersAPI} from '../services/UsersService'
import {authAPI} from '../services/AuthService'
import {appsAPI} from '../services/AppsService'
import {crmAPI} from '../services/CRMService'
import {cdrAPI} from '../services/CDRService'
import {csrAPI} from '../services/CSRService'
import {promptAPI} from '../services/PromptService'
import {accountUsersAPI} from '../services/AccountUsersService'
import cdrFilterSlice from '../modules/cdr/slices/cdrFilterSlice'
import csrFilterSlice from '../modules/csr/slices/csrFilterSlice'
import lrFilterSlice from '../modules/csr/slices/lrFilterSlice'
import erFilterSlice from '../modules/csr/slices/erFilterSlice'
import hrFilterSlice from '../modules/csr/slices/hrFilterSlice'

const authPersistConfig = {
  key: 'callbee:auth',
  storage: storage,
  whitelist: ['accessToken'],
}

export const authPersistor = persistReducer(authPersistConfig, AuthSlice)

const accountPersistConfig = {
  key: 'callbee:account',
  storage,
  whitelist: ['currentAccountId'],
}

export const accountPersistor = persistReducer(accountPersistConfig, AccountSlice)

const cdrFilterPersistConfig = {
  key: 'callbee:cdr:filter',
  storage,
}

const csrFilterPersistConfig = {
  key: 'callbee:csr:filter',
  storage,
}
const lrFilterPersistConfig = {
  key: 'callbee:lr:filter',
  storage,
}

const erFilterPersistConfig = {
  key: 'callbee:er:filter',
  storage,
}

const hrFilterPersistConfig = {
  key: 'callbee:hr:filter',
  storage,
}

const cdrFilterPersistor = persistReducer(cdrFilterPersistConfig, cdrFilterSlice)
const csrFilterPersistor = persistReducer(csrFilterPersistConfig, csrFilterSlice)
const lrFilterPersistor = persistReducer(lrFilterPersistConfig, lrFilterSlice)
const erFilterPersistor = persistReducer(erFilterPersistConfig, erFilterSlice)
const hrFilterPersistor = persistReducer(hrFilterPersistConfig, hrFilterSlice)

const store = configureStore({
  reducer: {
    hrFilter: hrFilterPersistor,
    erFilter: erFilterPersistor,
    lrFilter: lrFilterPersistor,
    csrFilter: csrFilterPersistor,
    cdrFilter: cdrFilterPersistor,
    account: accountPersistor,
    authReduser: authPersistor,
    [usersAPI.reducerPath]: usersAPI.reducer,
    [authAPI.reducerPath]: authAPI.reducer,
    [appsAPI.reducerPath]: appsAPI.reducer,
    [crmAPI.reducerPath]: crmAPI.reducer,
    [cdrAPI.reducerPath]: cdrAPI.reducer,
    [csrAPI.reducerPath]: csrAPI.reducer,
    [promptAPI.reducerPath]: promptAPI.reducer,
    [accountUsersAPI.reducerPath]: accountUsersAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(usersAPI.middleware)
      .concat(authAPI.middleware)
      .concat(appsAPI.middleware)
      .concat(crmAPI.middleware)
      .concat(cdrAPI.middleware)
      .concat(csrAPI.middleware)
      .concat(promptAPI.middleware)
      .concat(accountUsersAPI.middleware),
  devTools: process.env.NODE_ENV === 'development',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store)

export default store
